"use client";

import PageWrapper from "./components/ui/PageWrapper";
import BlockGrid from "./components/TireReading/BlockGrid";
import TireReadingInfo from "./components/TireReading/TireReadingInfo";
import TireActionBlock from "./components/TireReading/TireActionBlock";
import Loader from "./components/ui/Loader";
import { useTireReading } from "@/app/context/TireReadingContext";
import { ArrowLeft, ArrowRight } from "lucide-react";
import HistoryBar from "./components/TireReading/HistoryBar";

export default function Home() {
  const { currentReading, connectionStatus, goToPreviousReading, goToNextReading } = useTireReading();

  return (
    <PageWrapper>
      <div className="flex flex-col items-center justify-center w-full p-4 h-screen gap-8">
        <TireReadingInfo />
        <div className="flex flex-col items-center justify-between w-full h-screen gap-8 p-4">
          <BlockGrid />
          <HistoryBar />
          <div className="flex flex-row items-center justify-end w-full gap-8">
            <TireActionBlock code="Anders" />
          </div>
        </div>
        {/* Navigation buttons bottom left */}
        <div className="fixed bottom-8 left-8 flex flex-row gap-4 z-50">
          <button
            onClick={goToPreviousReading}
            className="w-48 h-48 rounded-2xl bg-gray-200 hover:bg-gray-300 shadow flex items-center justify-center text-3xl"
            aria-label="Previous reading"
          >
            <ArrowLeft size={64} />
          </button>
          <button
            onClick={goToNextReading}
            className="w-48 h-48 rounded-2xl bg-gray-200 hover:bg-gray-300 shadow flex items-center justify-center text-3xl"
            aria-label="Next reading"
          >
            <ArrowRight size={64} />
          </button>
        </div>
      </div>

      {/* Loader as overlay, shown only when currentReading is null */}
      <Loader loading={!currentReading} status={connectionStatus} />
    </PageWrapper>
  );
}
